import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import Button from '@ingka/button';
import { ListViewItem } from '@ingka/list-view';
import speechBubbleIcon from '@ingka/ssr-icon/paths/speech-bubble';
import speechBubbleActiveIcon from '@ingka/ssr-icon/paths/speech-bubble-active';
import { selectMessages } from '@repo/api-adapters/selectors/order-messages.selectors';
import { translate } from '@repo/phrase';
import { hasItems } from '@repo/utils/type.utils';

import { MODAL } from '@/components/modals/asset-modal.types';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

import type { AssetActionProps } from '../../asset-context-buttons.types';

import styles from '../../styles.module.scss';

const AssetMessageButton = () => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    const messages = selectMessages(data);
    const hasMessages = hasItems(messages);

    return (
        <Button
            iconOnly
            size="small"
            type="tertiary"
            ssrIcon={hasMessages ? speechBubbleActiveIcon : speechBubbleIcon}
            onClick={() => {
                setActiveModal(MODAL.MESSAGE);
            }}
            className={String(styles.hide_mobile)}
            data-testid="action-toggle-message"
            aria-label={translate('messages_modal')}
        />
    );
};

const AssetMessageListItem = ({ onClose, context }: AssetActionProps) => {
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    return (
        <ListViewItem
            title={translate('messages_modal')}
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            control="navigational"
            emphasised={context === 'modal'}
            className={String(styles.hide_desktop)}
            onClick={() => {
                setActiveModal(MODAL.MESSAGE);
                onClose?.();
            }}
        />
    );
};

export const AssetMessageAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return <AssetMessageButton key="message-button" {...props} />;
    }
    return <AssetMessageListItem key="message-list-item" {...props} />;
};
